if($('footer#footer').length){
    $('.newsletter-header h4').text(newsletterTitle)
    $('#formNewsletterWidget button[type="submit"]').text('Odebírat');
    $('#formNewsletterWidget input[type="email"]').attr('placeholder', 'Váš @ e-mail');
    $('#signature').append('<span class="signatureFirm"> | <a href="https://www.d2solutions.cz/" target="_blank">D2solutions</a> | <a href="https://www.shopcode.cz/" target="_blank">ShopCode</a></span>')
    $(document).on('click', '.custom-footer>div h4', function(){
        $(this).closest('.custom-footer>div').toggleClass('openIt')
    });
    $('header#header').before($('footer#footer .scroolStrip'))
    $('footer#footer .topContacts ul').prepend($('footer#footer .contact-box li span.mail').closest('li').clone())
    $('footer#footer .topContacts ul').prepend($('footer#footer .contact-box li span.tel').closest('li').clone())
    $('.responsive-tools').append($('footer#footer .topContacts'))
}